const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { getLoopQueryOptions } from '@/common/queries/useLoopsQuery';
import { isHttpError } from '@/common/utils/isHttpError';
const paramsSchema = z.object({
  loopId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      loopId,
      org
    }
  }) => {
    try {
      await queryClient.ensureQueryData(getLoopQueryOptions({
        loopId
      }));
    } catch (error) {
      if (isHttpError(error, 404)) {
        throw redirect({
          to: '/org/$org',
          params: {
            org
          }
        });
      }
      throw error;
    }
  }
});